var TableHeading = /** @class */ (function () {
    function TableHeading(text, value, sortable, width) {
        if (sortable === void 0) { sortable = true; }
        if (width === void 0) { width = ''; }
        return {
            text: text,
            value: value,
            sortable: sortable,
            width: width,
        };
    }
    return TableHeading;
}());
export { TableHeading };
